import { Grid as MuiGrid } from '@mui/material';

import type { GridProps } from './types';

const Grid = (props: GridProps) => {
  return <MuiGrid {...props} />;
};

export default Grid;
